<div class="ubi" [class.is-disabled]="disabled">
	<!-- Sin pais de contrato todavia -->
	<p class="ubi-msg" *ngIf="!codigoPais">{{ "centro.ubicacion.sinPais" | translate }}</p>

	<ng-container *ngIf="codigoPais">
		<!-- Buscador (se dispara con la lupa / Enter; NO en cada tecla) -->
		<div class="ubi-search">
			<mat-icon class="ubi-search-ic" [inline]="true">search</mat-icon>
			<input
				type="text"
				[value]="searchText"
				(input)="searchText = $any($event.target).value"
				(keyup.enter)="buscar()"
				[placeholder]="'centro.ubicacion.buscarPlaceholder' | translate"
				[disabled]="disabled"
			/>
			<button
				type="button"
				class="ubi-search-clear"
				*ngIf="searchText || busquedaHecha"
				(click)="limpiarBusqueda()"
				[attr.aria-label]="'common.clear' | translate"
			>
				<mat-icon [inline]="true">close</mat-icon>
			</button>
			<button
				type="button"
				class="ubi-search-btn"
				(click)="buscar()"
				[disabled]="disabled || buscando"
			>
				{{ "common.search" | translate }}
			</button>
		</div>

		<!-- Resultados de búsqueda -->
		<div class="ubi-results" *ngIf="busquedaHecha">
			<div class="ubi-loading" *ngIf="buscando">
				{{ "common.loading" | translate }}
			</div>
			<p class="ubi-msg" *ngIf="!buscando && !resultados.length">
				{{ "centro.ubicacion.sinResultados" | translate }}
			</p>
			<button
				type="button"
				class="ubi-result"
				*ngFor="let r of resultados"
				(click)="seleccionarResultado(r)"
				[title]="rutaResultado(r)"
			>
				<mat-icon [inline]="true">place</mat-icon>
				<span class="ubi-result-tx">
					<b>{{ r.nombre }}</b>
					<small>{{ rutaResultado(r) }}</small>
				</span>
			</button>
		</div>

		<!-- Seleccion actual (ruta legible) -->
		<div class="ubi-sel" *ngIf="selectedPath">
			<mat-icon [inline]="true">place</mat-icon>
			<span>{{ selectedPath }}</span>
		</div>

		<div class="ubi-loading" *ngIf="loadingRoot">{{ "common.loading" | translate }}</div>

		<!-- Pais no cargado en Dama -->
		<p class="ubi-msg ubi-warn" *ngIf="paisNoCargado">
			{{ "centro.ubicacion.paisNoCargado" | translate }}
		</p>

		<!-- Pais sin niveles inferiores -->
		<p class="ubi-msg ubi-info" *ngIf="sinNiveles">
			{{ "centro.ubicacion.sinNiveles" | translate }}
		</p>

		<!-- Arbol -->
		<div class="ubi-tree" *ngIf="root && !sinNiveles && !paisNoCargado">
			<ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: root, depth: 0 }"></ng-container>
		</div>
	</ng-container>
</div>

<ng-template #nodeTpl let-node let-depth="depth">
	<div
		class="ubi-node"
		[class.is-selected]="node.data.id === selectedId"
		[style.padding-left.px]="6 + depth * 16"
	>
		<!-- Twist (expandir/colapsar) -->
		<button
			type="button"
			class="ubi-twist"
			*ngIf="node.data.tieneHijos"
			(click)="toggle(node)"
			[attr.aria-expanded]="node.expanded"
		>
			<mat-icon [inline]="true">{{ node.expanded ? "expand_more" : "chevron_right" }}</mat-icon>
		</button>
		<span class="ubi-twist ubi-twist--leaf" *ngIf="!node.data.tieneHijos"></span>

		<!-- Etiqueta / seleccion -->
		<button
			type="button"
			class="ubi-label"
			[class.is-selectable]="node.data.seleccionable"
			[disabled]="disabled"
			(click)="seleccionar(node)"
			[title]="node.data.nombre"
		>
			<span class="ubi-radio" *ngIf="node.data.seleccionable" [class.on]="node.data.id === selectedId"></span>
			<span class="ubi-name">{{ node.data.nombre }}</span>
		</button>

		<mat-progress-spinner *ngIf="node.loading" diameter="14" mode="indeterminate"></mat-progress-spinner>
	</div>

	<ng-container *ngIf="node.expanded && node.children">
		<ng-container *ngFor="let child of node.children">
			<ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child, depth: depth + 1 }"></ng-container>
		</ng-container>
	</ng-container>
</ng-template>
